<script>
export default {
  props: {
    selectedDocument: {type: Object},
    selectedStationery: {type: Object},
    senderBlock: {type: String},
    addressBlock: {type: String},
    address: {type: Object},
    errors: {type: Array}
  },
  data: () => ({
    isFormValid: true
  }),
  computed: {
    localSenderBlock: {
      get() {
        return this.senderBlock;
      },
      set(value) {
        this.$emit('update:sender-block', value);
        this.debouncedPreviewCoverSheet()
      }
    },
    localAddressBlock: {
      get() {
        return this.addressBlock;
      },
      set(value) {
        this.$emit('update:address-block', value);
        this.debouncedPreviewCoverSheet()
      }
    },
    localAddress: {
      get() {
        return this.address;
      },
      set(value) {
        this.$emit('update:address', value);
        this.debouncedPreviewCoverSheet()
      }
    },
    senderBlockRules() {
      if(this?.errors?.length){
        return [this.enforceLineLength];
      }
      return []
    },
    addressBlockRules() {
      if(this?.errors?.length){
        return [this.enforceLineLength,
          v => this.isRequired(
            v, this.$t('component.documentValidation.coverSheet.letterAddressDetails.textarea.required'))];
      }
      return []
    },
    zipCodeRules() {
      if(this?.errors?.length){
        return [v => !!v || this.setFormValidity(
          false, this.$t('component.documentValidation.coverSheet.letterAddressDetails.zip.required')), v => /^[0-9]{5}$/.test(v)
          || this.setFormValidity(
            false, this.$t('component.documentValidation.coverSheet.letterAddressDetails.zip.invalid'))];
      }
      return []
    },
    cityRules() {
      if(this?.errors?.length){
        return [v => !!v || this.setFormValidity(
          false, this.$t('component.documentValidation.coverSheet.letterAddressDetails.city.required'))];
      }
      return []
    }
  },
  watch: {
    selectedDocument() {
      this.setFormValidity(true);
    }
  },
  methods: {
    setFormValidity(isValid, errorMessage = null) {
      this.isFormValid = isValid
      return errorMessage !== null && errorMessage
    },
    debouncedPreviewCoverSheet() {
      this.$emit('debounced-preview-cover-sheet', {
        senderBlock: this.localSenderBlock,
        addressBlock: this.localAddressBlock,
        address: this.localAddress
      });
    },
    isRequired(validity, message){
      return !!validity || this.setFormValidity(false, message)
    },
    enforceLineLength(value) {
      if (value !== undefined && value !== null) {
        const lines = value.split('\n')
        if (lines.length > 4) {
          return this.$t('component.documentValidation.coverSheet.letterAddressDetails.max.4.lines')
        }
        for (let line of lines) {
          if (line.length > 60) {
            return this.$t('component.documentValidation.coverSheet.letterAddressDetails.max.60.chars')
          }
        }
        return true
      }
      return this.$t('component.documentValidation.coverSheet.letterAddressDetails.fill.out.address')
    },
  }
}
</script>
<template>
  <v-card-text>
    <v-row>
      <v-col v-if="errors.length > 0">
        <v-alert v-for="(error, index) in errors" :key="index" type="error">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-if="selectedStationery === null || selectedStationery === 0 || selectedStationery === undefined"
          v-model="localSenderBlock"
          outlined
          :rules="senderBlockRules"
          :label="$t('component.documentValidation.coverSheet.letterAddressDetails.sender.block')"
          required
          @input="debouncedPreviewCoverSheet"></v-text-field>
        <v-textarea
          v-model="localAddressBlock"
          clearable
          :max-rows="4"
          :rows="4"
          counter
          outlined
          required
          class="sender-block-textarea"
          :rules="addressBlockRules"
          :label="$t('component.documentValidation.coverSheet.letterAddressDetails.address.block')"
          :placeholder="$t('component.documentValidation.coverSheet.letterAddressDetails.address.block')"
          maxlength="240"
          style="line-height: 17px!important;"
          @input="debouncedPreviewCoverSheet"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
          v-model="localAddress.zipCode"
          outlined
          :label="$t('component.documentValidation.coverSheet.letterAddressDetails.zip')"
          :rules="zipCodeRules"
          required
          @input="debouncedPreviewCoverSheet"></v-text-field>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="localAddress.city"
          outlined
          :label="$t('component.documentValidation.coverSheet.letterAddressDetails.city')"
          :rules="cityRules"
          required
          @input="debouncedPreviewCoverSheet"></v-text-field>
      </v-col>
    </v-row>
    <v-text-field
      v-model="localAddress.country"
      outlined
      :label="$t('component.documentValidation.coverSheet.letterAddressDetails.country')"
      disabled
      required
      @input="debouncedPreviewCoverSheet"></v-text-field>
  </v-card-text>
</template>
